<template>
    <div class="about-page">
        <v-container fluid class="pa-0 home-page">

            <!-- HERO SECTION -->
            <v-container fluid class="hero-container pa-0">
                <div class="hero-panel">
                    <HeroBanner />
                </div>
            </v-container>

            <!-- FEATURED CRUISES -->
            <v-container fluid class="bg-light lift-up">
                <v-container class="section-inner py-0" fluid>
                    <v-row class="align-center justify-space-between mb-4 mx-8" no-gutters>
                        <h3 class="text-h3 font-weight-bold mb-0 section-title">
                            <span class="un">un</span>Covered Gems
                        </h3>

                        <v-btn class="explore-link" variant="text" append-icon="mdi-arrow-right" density="comfortable"
                            to="/gems">
                            Explore All
                        </v-btn>
                    </v-row>
                    <FeaturedCruiseCarousel :cruises="cruises" />
                </v-container>
            </v-container>

            <section class="promo-wrap">
                <v-container class="promo-inner">
                    <v-row class="align-center promo-row">
                        <!-- LEFT SIDE -->
                        <v-col cols="12" md="6" class="left-col">
                            <div class="blob-wrapper">
                                <!-- teal blob background -->
                                <img class="blob-bg" :src="pic11Img" alt="" />

                                <!-- luggage on top -->
                                <img class="luggage-img" :src="pic6Img" alt="Suitcases packed for vacation" />
                            </div>
                        </v-col>

                        <!-- RIGHT SIDE -->
                        <v-col cols="12" md="5" class="right-col text-md-left text-center">
                            <h2 class="promo-title">Pack Your Bags</h2>

                            <p class="promo-body">
                                We connect you to exclusive savings on cruises, hotel stays, and resort escapes. With
                                our easy booking and trusted offers, your next vacation is closer (and more affordable)
                                than you think!
                            </p>

                            <v-btn class="cta-btn mt-6" rounded="pill" height="56" min-width="200" color="primary">
                                Get started
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>

                <TestimonialRotator :testimonials="testimonials" />

            </section>

            <!-- CONFIDENCE FOR EVERY MILE -->
            <v-container fluid class="py-16 bg-light">
                <v-container class="confidence-inner">
                    <h2 class="text-h4 text-md-h3 font-weight-bold text-center mb-10 confidence-title">
                        Confidence for Every Mile
                    </h2>
                    <div class="confidence-track">
                        <!-- icons + labels -->
                        <div class="confidence-items">
                            <div v-for="(feature, i) in features" :key="i" class="confidence-item">
                                <div class="confidence-icon">
                                    <v-icon :icon="feature.icon" size="60" />
                                </div>
                                <p class="confidence-label">
                                    {{ feature.line1 }}<br />
                                    {{ feature.line2 }}
                                </p>
                            </div>
                        </div>
                    </div>

                </v-container>
            </v-container>


        </v-container>
    </div>
</template>


<script>
import FeaturedCruiseCarousel from '@/components/FeaturedCruiseCarousel.vue';
//import SearchBar from '@/components/SearchBar.vue';
import HeroBanner from '@/components/HeroBanner.vue';
import TestimonialRotator from '@/components/TestimonialRotator.vue';

export default {
    components: {
        FeaturedCruiseCarousel,
        //SearchBar,
        HeroBanner,
        TestimonialRotator
    },
    data() {
        return {
            cruises: [
                {
                    id: 1,
                    description: 'Bahamas Getaway',
                    ship: 'Ocean Dream',
                    port: 'Miami, FL',
                    numberOfNights: '3',
                    imageUrl: 'https://placehold.co/600x400?text=Cruise+1',
                    dateOfSailing: '2026-08-01',
                },
                {
                    id: 2,
                    description: 'Bahamas Getaway',
                    ship: 'Ocean Dream',
                    port: 'Miami, FL',
                    numberOfNights: '3',
                    imageUrl: 'https://placehold.co/600x400?text=Cruise+2',
                    dateOfSailing: '2026-08-01',
                },
                {
                    id: 3,
                    description: 'Bahamas Getaway',
                    ship: 'Ocean Dream',
                    port: 'Miami, FL',
                    numberOfNights: '3',
                    imageUrl: 'https://placehold.co/600x400?text=Cruise+3',
                    dateOfSailing: '2026-08-01',
                },
                {
                    id: 4,
                    description: 'Bahamas Getaway',
                    ship: 'Ocean Dream',
                    port: 'Miami, FL',
                    numberOfNights: '3',
                    imageUrl: 'https://placehold.co/600x400?text=Cruise+4',
                    dateOfSailing: '2026-08-01',
                },
                {
                    id: 5,
                    description: 'Bahamas Getaway',
                    ship: 'Ocean Dream',
                    port: 'Miami, FL',
                    numberOfNights: '3',
                    imageUrl: 'https://placehold.co/600x400?text=Cruise+5',
                    dateOfSailing: '2026-08-01',
                },
                {
                    id: 6,
                    description: 'Bahamas Getaway',
                    ship: 'Ocean Dream',
                    port: 'Miami, FL',
                    numberOfNights: '3',
                    imageUrl: 'https://placehold.co/600x400?text=Cruise+6',
                    dateOfSailing: '2026-08-01',
                }
            ],
            features: [
                { line1: 'Trusted by', line2: 'Travel Pros', icon: 'mdi-heart' },
                { line1: 'Exclusive', line2: 'Inventory', icon: 'mdi-sale' },
                { line1: 'Built-In', line2: 'Perks', icon: 'mdi-gift' },
                { line1: 'Streamlined &', line2: 'Secure', icon: 'mdi-shield' },
                { line1: 'Transparent', line2: 'Pricing', icon: 'mdi-cash-multiple' }
            ],
            testimonials: [
                { text: 'Got an amazing deal for my friend’s birthday and decided to go for it! Booking was easy and everything showed up in my Royal Caribbean account the nextday. Will be my first stop for my next cruise!', author: '— Jen S', location: 'Orlando' },
                { text: 'Found exactly what I wanted for much cheaper than when I looked on Expedia! Everything was perfect!', author: '— Christine M', location: 'Boston' },
                { text: 'My sister got sick and couldn’t travel anymore. UnBooked was able to swap the names so my friend could go instead.', author: '— Alex R', location: 'St Petersburg' }
            ],
            pic6Img: new URL('@/assets/imgs/suitcase-combo.png', import.meta.url).href,
            pic11Img: new URL('@/assets/imgs/blob.png', import.meta.url).href,
        };
    },
    methods: {
        handleSearch() {
            console.log('Search clicked')
        }
    }
};
</script>

<style scoped>
.home-page {
  position: relative;
  min-height: 100%;
  background-color: #ffffff; /* beige background sits behind everything */
  display: flex;
  flex-direction: column;
  z-index: 0;
}

.hero-container {
  position: relative;
  z-index: 1; /* sits above beige, below floating elements */
}

.hero-panel {
  margin: 0 auto;
  z-index: 2; /* ensure the blue panel is above beige */
  position: relative;
}


.lift-up {
    margin-top: -100px;
}

.section-inner {
    max-width: 1440px;
    /* <- change to 12240px if that was not a typo */
    margin: 120px auto 0;
    /* top spacing, center horizontally */
    padding-inline: 16px;
    /* gutter on small screens */
}

.section-title {
    color: #333333;
}

.explore-link {
    color: #333333;
    text-transform: none;
    font-size: 14pt;
    letter-spacing: .2px;
}

.explore-link:hover {
    transform: translateX(4px);
}


.testimonial-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border-radius: 12px;
}

.testimonial-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

/* Section spacing */
.promo-wrap {
    background-color: #ffffff;
    padding-block: clamp(2rem, 3vw, 4rem);
    overflow-x: hidden;
    /* so blob can hang off the left edge without causing scrollbars */
}

/* Similar page width to your screenshot (big gutter on sides at desktop) */
.promo-inner {
    max-width: 1400px;
}

/* Make columns stack on mobile but sit side-by-side on md+ */
.promo-row {
    /* when stacked (xs/sm), we want the left art to touch viewport left */
}

/* LEFT SIDE LAYOUT */
.left-col {
    display: flex;
    justify-content: flex-start;
    /* we let the blob slide left past container padding */
    position: relative;
}

/* wrapper that can overflow left on desktop and still scale down on mobile */
.blob-wrapper {
    position: relative;
    /* let it be wide on desktop */
    width: clamp(320px, 50vw, 800px);
    max-width: 800px;

    /* pull it left so it "clips" at the page edge like your screenshot */
    margin-left: clamp(-200px, -5vw, -150px);

    /* keep some bottom space in mobile so text doesn't overlap */
    margin-bottom: 2rem;
}

/* teal blob background image */
.blob-bg {
    display: block;
    width: 100%;
    height: auto;
}

/* luggage floats above blob with drop shadow */
.luggage-img {
    position: absolute;
    inset: 0;
    width: 70%;
    max-width: 600px;
    margin: auto;
    filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.18));
    pointer-events: none;
    transform: translate(20%, 0%);
}

/* RIGHT SIDE */
.right-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.promo-title {
    color: #2f2f2f;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.2px;
    font-size: clamp(1.75rem, 1vw + 1.25rem, 2.25rem);
    /* ~28px-36px */
    margin-bottom: 1rem;
}

.promo-body {
    color: #2f2f2f;
    font-weight: 400;
    line-height: 1.5;
    font-size: clamp(1rem, 0.3vw + 0.9rem, 1.25rem);
    /* ~16-20px */
    max-width: 48ch;
    margin-inline: auto;
}

.cta-btn {
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.2;
    letter-spacing: 0.2px;
    padding-inline: 24px;
    text-transform: none;
    box-shadow: 0 10px 20px rgba(27, 34, 90, 0.3);
}

/* desktop tweaks */
@media (min-width: 960px) {
    .promo-body {
        margin-inline: 0;
    }

    .blob-wrapper {
        margin-bottom: 0;
    }
}

.confidence-inner {
    max-width: 1100px;
}

.confidence-title {
    color: #222222;
}

/* Outer wrapper for line + icons */
.confidence-track {
    position: relative;
    max-width: 900px;
    margin: 0 auto;
    padding-block: 1.5rem;
}

/* the dashed path made of images */
.confidence-line {
    position: absolute;
    left: 0;
    right: 0;
    top: 64px;
    /* push under the 52px icons; tweak 60–70px to taste */
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
    z-index: 0;
}

.line-segment {
    flex: 1 1 auto;
    max-width: 100px;
    /* prevents weird stretching; tweak for your art */
    height: 16px;
    /* tweak to your image height */
    object-fit: contain;
}

/* icons row */
.confidence-items {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1.5rem;
}

.confidence-item {
    text-align: center;
    flex: 1 1 0;
}

.confidence-icon {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 0.75rem;
    color: #2436c8;
}

.confidence-label {
    font-size: 0.95rem;
    line-height: 1.3;
    font-weight: 600;
    color: #222222;
}

/* Responsive: hide line on small screens if it looks cramped */
@media (max-width: 960px) {
    .confidence-line {
        display: none;
    }

    .confidence-items {
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 1.5rem;
    }

    .confidence-item {
        flex: 0 1 45%;
    }
}

@media (max-width: 600px) {
    .confidence-item {
        flex: 0 1 100%;
    }
}
</style>